import { useTranslate } from '@/translations';
import { Damage } from '@/types';
import { Modal } from 'antd';
import React, { FC } from 'react';
import { DamagePartsGrid } from './DamagePartsGrid';
import { DamageSupplierPartsGrid } from './DamageSupplierPartsGrid';
import { excludeIstaDamageLines } from '../isIstaDamageLine';

interface AddDamagePartsPopupProps {
  inspectionId: number;
  damageLines: Damage[];
  isLabour: boolean;
  visible: boolean;
  canEditParts?: boolean;
  damageLinesLoading?: boolean;
  onSubmit: () => void | Promise<unknown>;
  onClose: () => void;
}
export const AddDamagePartsPopup: FC<AddDamagePartsPopupProps> = ({
  inspectionId,
  damageLines,
  isLabour,
  visible,
  canEditParts,
  damageLinesLoading,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslate();
  const selectableDamageLines = excludeIstaDamageLines(damageLines);

  return (
    <Modal
      open={visible}
      title={`Add ${isLabour ? t('parts') : t('partsFludids')}`}
      width="80%"
      onCancel={onClose}
      footer={null}
    >
      {isLabour ? (
        <DamageSupplierPartsGrid
          inspectionId={inspectionId}
          damageLines={selectableDamageLines}
          disabled={!canEditParts}
          damageLinesLoading={damageLinesLoading}
          onSubmit={async () => {
            await onSubmit();
            onClose();
          }}
        />
      ) : (
        <DamagePartsGrid
          inspectionId={inspectionId}
          damageLines={selectableDamageLines}
          disabled={!canEditParts}
          damageLinesLoading={damageLinesLoading}
          onSubmit={async () => {
            await onSubmit();
            onClose();
          }}
        />
      )}
    </Modal>
  );
};
